<template>
  <div class="cashflow-tour">
    <div class="shadow-container">
      <div class="sticky-header">
        <span class="title sticky-title">היי {{ householdName }}</span>
        <img class="icon" :src="require('@/assets/icons/close.svg')" v-on:click="closeTour">
      </div>

      <div class="title header">נעבור על איך בנינו את התזרים</div>
      <div class="text footer">
        <div>
          <span>התזרים בנוי מ</span><span class="bold green">הכנסות קבועות</span>
        </div>
        <div>
          <span> ו</span><span class="bold green">הכנסות משתנות</span>
        </div>
        <div>
          <span>ומהוצאות </span><span class="bold coral">קבועות</span><span>, </span><span class="bold blue">חוזרות</span>
          <span> ו</span><span class="bold mustard">משתנות</span><span>.</span>
        </div>
      </div>

      <div class="text footer">איך זה נראה בתזרים?</div>

      <div class="title">הכנסות קבועות</div>
      <div class="text">
        <div>כל הכנסה שאנחנו יודעים בוודאות שנכנסת </div>
        <div>בכל חודש - כמו משכורת או קצבה.</div>
      </div>
      <img class="image" :src="require('@/assets/cashflow-tour/income-fixed.png')">
      <div class="text">גם אם הסכום עצמו משתנה קצת ביחס לחודשים קודמים, זה בסדר - המערכת שלנו תזהה את השינוי ותעדכן את התזרים בהתאם.</div>

      <div class="title header"> הכנסות משתנות</div>
      <div class="text">
        <div>הכנסה לא קבועה, שכנראה לא תקרה בחודש הבא. זו הכנסה שאנחנו מתכוונים לממן איתה את ההוצאות של החודש.</div>
      </div>
      <img class="image" :src="require('@/assets/cashflow-tour/income-variable.png')">
      <div class="text">
        <span>אפשר להעביר </span><span class="bold green">הכנסה ממשתנה</span>
        <span>ל</span><span class="bold green">קבועה</span>
      </div>
      <div class="text">עם העפרון ✏️.</div>

      <div class="title header">הוצאות קבועות</div>
      <div class="text">
        <div>כל הוצאה שהתחייבנו עליה מראש ויורדת באופן קבוע בכל חודש, כמו - משכנתא 🏡, ביטוח 📄, </div>
        <div>חשמל ⚡️.</div>
      </div>
      <img class="image" :src="require('@/assets/cashflow-tour/fixed.png')">
      <div class="text footer">גם אם הסכום עצמו משתנה קצת ביחס לחודשים קודמים, זה בסדר - המערכת שלנו תזהה את השינוי ותעדכן את התזרים בהתאם.</div>
      <div class="text">
        <span>אפשר לשנות את ה</span><span class="bold coral">קטגוריה</span>
        <span>של ה</span><span class="bold coral">הוצאה הקבועה</span>
        <span>עם העפרון ✏️.</span>
      </div>

      <div class="title header">הוצאות חוזרות</div>
      <div class="text">
        <div>כל הוצאה שחוזרת על עצמה בכל חודש, כמו - קניות בסופר 🛒, הוצאות רכב 🚗 (דלק, חניה, כבישי אגרה), אוכל בחוץ 🥡.</div>
        <div>אנחנו כנראה נוציא אותן במהלך החודש, אבל יש לנו שליטה על כמה נוציא.</div>
      </div>
      <img class="image" :src="require('@/assets/cashflow-tour/recurring.png')">
      <div class="text footer">
        <div>שימו ♥️ - ההוצאות החוזרות בסופר מוצגות ברמה השבועית, יתר ההוצאות החוזרות מוצגות ברמה החודשית.</div>
        <div>סכום ההוצאות החוזרות שהמערכת צופה מחושב לפי ממוצע ההוצאות של החודשים האחרונים ומתעדכן לאורך החודש בהתאם להוצאות בפועל.</div>
      </div>

      <div class="text">
        <span>אפשר לשנות את ה</span><span class="bold blue">קטגוריה</span>
        <span>של ה</span><span class="bold blue">הוצאה החוזרת</span>
        <span>או להעביר אותה ל</span><span class="bold mustard">הוצאות המשתנות</span>
        <span>עם העפרון ✏️.</span>
      </div>

      <div class="title header">הוצאות משתנות️</div>
      <div class="text">
        <span>אחרי שהמערכת הורידה מה</span><span class="bold green">הכנסות</span>
        <span>הצפויות את כל ה</span><span class="bold coral">הוצאות הקבועות</span><span> (משכנתא, ביטוח, חשמל️)</span>
        <span>וה</span><span class="bold blue">הוצאות החוזרות</span><span> (סופר, רכב, אוכל בחוץ)</span>
        <span>, הסכום שנשאר הוא יתרת</span>
      </div>
      <div class="text">
        <span> ה</span><span class="bold mustard">הוצאות המשתנות</span><span>.</span>
      </div>
      <div class="text sub-header">
        <span class="bold">זה המספר הכי חשוב בתזרים </span>
        <span>- אם לא נוציא יותר ממנו,
        נסיים את החודש בתזרים חיובי! אלו ההוצאות של החיים עצמם, כל ההוצאות הלא מתוכננות שלנו לחודש הקרוב.</span>
      </div>
      <img class="image" :src="require('@/assets/cashflow-tour/variable.png')">
      <div class="text footer">הבוט שלנו ישלח מעקב 3 פעמים בשבוע על מצב התזרים - כמה כסף נשאר להוציא בהוצאות המשתנות השבוע.</div>

      <div class="text footer">
        <span>אפשר להעביר כל </span><span class="bold mustard">הוצאה משתנה</span>
        <span>ל</span><span class="bold blue">הוצאות החוזרות</span>
        <span>או ל</span><span class="bold coral">הוצאות הקבועות</span>
        <span>עם העפרון ✏️.</span>
      </div>

      <div class="done-button">
        <riseup-button :action="() => closeTour()"
                       :size="'normal'"
                       :title="`לתזרים של ${this.monthName}`"/>
      </div>
    </div>
  </div>
</template>

<script>
import BaseUI from 'base-ui';
import { mapActions, mapGetters } from 'vuex';
import Segment from '../../../../../Segment';

export default {
  name: 'CashflowTour',
  components: {
    RiseupButton: BaseUI.RiseupButton,
  },
  async created() {
    Segment.trackUserGot('CashflowTourEntered', { cashflowApp: true });
  },
  computed: {
    ...mapGetters('session', ['householdName']),
    ...mapGetters('cashflowView', ['monthName']),
  },
  methods: {
    ...mapActions('cashflowTour', ['setPostTour']),
    async closeTour() {
      Segment.trackUserInteraction('CashflowTourDoneClicked');
      this.setPostTour();
      window.scrollTo(0, 0);
    },
  },
};
</script>

<style lang="scss" scoped>
  @import '../../../../../../node_modules/base-ui/src/scss/riseup-colors';

  .cashflow-tour {
    width: 100%;
    text-align: right;
    display: flex;

    .shadow-container {
      width: 100%;
      background-color: $riseup_white_1;


      .title {
        padding: 0 30px;
        width: 100%;
        font-family: GretaSans;
        font-size: 24px;
        line-height: 32px;
      }

      .text {
        padding: 0 30px;
        line-height: 1.5;
        font-size: 16px;

        .bold {
          font-weight: bold;

          &.green {
            color: $riseup_green;
          }

          &.coral {
            color: $riseup_coral;
          }

          &.blue {
            color: $riseup_light_blue;
          }

          &.mustard {
            color: $riseup_mustard;
          }
        }
      }

      .image {
        width: 328px;
        box-shadow: 2px 2px 8px 0 rgba(0, 0, 0, 0.25);
        display: block;
        margin: 7px auto 8px auto;
      }

      .header {
        padding-top: 45px;
      }

      .footer {
        padding-bottom: 24px;
      }

      .sub-header {
        padding-top: 24px;
      }

      .sticky-header {
        height: 40px;
        background-color: $riseup_white;
        box-shadow: 2px 2px 8px 0 rgba(0, 0, 0, 0.25);
        position: -webkit-sticky;
        position: sticky;
        top: 0;

        .sticky-title {
          display: inline-block;
          padding-top: 2px;
        }

        .icon {
          position: relative;
          top: -27px;
          left: -327px;
        }
      }

      .done-button {
        padding: 32px;
        text-align: center;
        background-color: $riseup_white;
        border-radius: 8px 8px 0 0;
        box-shadow: 0 -1px 5px 0 rgba(0, 0, 0, 0.2);
        margin: 10px 0 0 0;
      }

    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/responsive-pages/authenticated/cashflow-tour/cashflow-view-tour/CashflowTour.vue